(function() {
'use strict';

angular
    .module('TR')
    .controller('MarhabaOptions', MarhabaOptions);

function MarhabaOptions(marhabaService, $routeParams, $location, basketStore, basketService, resourceService, tripService, occupancyService, $sce, analytics) {
    const cm = this;
    cm.updateChauffeurNum = updateChauffeurNum;
    cm.changeMarhaba = changeMarhaba;

    analytics.track('mixpanel', 'MarhabaOptions');

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        const basketId = trip.BasketId;
        const searchId = trip.MarhabaRequest.AvailabilitySearchId;
        const productId = $routeParams.productId;

        cm.noOfPassengers = occupancyService.getNumberOfNonInfantPassengers();
        cm.selection = { auxillaries: {} };

        // Products are splitted between chauffeurs and auxillaries
        cm.auxillaryProducts = [];
        cm.chauffeurs = [];
        cm.lounges = [];
        cm.isLounge = false;
        cm.isTransfer = false;

        basketStore.addMarhaba(searchId, productId, basketId).then(function(productInfo) {
            // Summary for header overlay
            cm.summary = {
                productName: productInfo.Details.MarhabaQuote.Name,
                terminal: trip.MarhabaRequest.Terminal.Name,
                date: trip.MarhabaRequest.DateAndTime,
                description: $sce.trustAsHtml(productInfo.Details.MarhabaQuote.Description),
                price: productInfo.Details.MarhabaQuote.TotalPrice
            };

            const type = productInfo.Details.MarhabaQuote.Type;
            cm.isLounge = type === 5;
            cm.isTransfer = type === 2;

            cm.confirmMarhaba = confirmMarhaba;

            const res = marhabaService.adjustMarhabaOptions(productInfo, resourceService.get('SELECTCHAUFFEUR'));
            if (res.noOptions) {
                cm.noOptions = res.noOptions;
            } else {
                cm.auxillaryProducts = res.auxillaryProducts;
                cm.chauffeurs = res.chauffeurs;
                cm.lounges = res.lounges;
                cm.selection.chauffeur = res.selectedChauffeur;
            }
            cm.loaded = true;

            function confirmMarhaba() {

                trackOptionsInMixpanel();

                // The chauffeurs is treated as any other auxillaries
                if (cm.selection.chauffeur && cm.selection.chauffeur.Id !== 0) {
                    cm.selection.auxillaries[cm.selection.chauffeur.Id] = cm.selection.chauffeur.Num;
                }

                // Lounges is treated as any other auxillaries
                // Only one Lounge can be added
                if (cm.selection.lounge) {
                    cm.selection.auxillaries[cm.selection.lounge.Id] = cm.noOfPassengers;
                }

                // Normalization of options for the request
                const options = [];
                for (const auxId in cm.selection.auxillaries) {
                     const quantity = cm.selection.auxillaries[auxId];

                    if (quantity > 0) {
                        options.push({ OptionId: auxId, ChosenQuantity: quantity });
                    }
                }

                // The marhaba product in the basket is removed and added again with all the options
                basketStore.addMarhaba(searchId, productId, basketId, options).then(function() {
                    basketStore.marhabaHolidayPath(basketId).then(function(asOption) {
                        if (asOption) {
                            $location.path(`holidays/options/${$routeParams.tripId}/${productId}`);
                        } else {
                            basketService.prepareMarhabaBooking($routeParams.tripId, productId);
                        }
                    });
                });
            }
        });
    });

    function updateChauffeurNum() {
        cm.selection.chauffeur.Num = 1;
    }

    function changeMarhaba() {
        basketService.changeJourneyUrl(45);
    }

    function trackOptionsInMixpanel() {
        const auxKeys = _.mapKeys(cm.selection.auxillaries, (value, key) => {
            let i = cm.auxillaryProducts.find(item => {
                return item.Id === key;
            });
            return i.Name;
        });

        const mixpanelOptions = _.mapValues(auxKeys, val => {
            return !!val;
        });

        mixpanelOptions.Chauffeur = _.has(cm, 'selection.chauffeur.Num');

        if (cm.selection.lounge !== undefined) {
            mixpanelOptions.Lounge = cm.selection.lounge.Name;
        }

        return analytics.track('mixpanel', 'MarhabaOptionsClick', mixpanelOptions);
    }
}
})();
